import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { renderMarkdown } from '@grc/markdown';

/**
 * Sanitised markdown display. @grc/markdown already escapes raw HTML;
 * DOMPurify here is defence in depth (PLAN §9, §22).
 */
export function Markdown({ markdown, className = '' }: { markdown: string; className?: string }) {
  const html = useMemo(
    () => DOMPurify.sanitize(renderMarkdown(markdown), { USE_PROFILES: { html: true } }),
    [markdown],
  );
  return <div className={`markdown-body ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
